import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  // 🔐 token check
  const token = localStorage.getItem("token");

  // ❌ token nahi hai → login
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  

  // ✅ token hai → page dikhao
  return children;
}

export default ProtectedRoute;
